import { NgModule } from '@angular/core';

import {NavCollapseComponent} from './nav-collapse/nav-collapse.component';
import {NavItemComponent} from './nav-item/nav-item.component';
import {NavGroupComponent} from './nav-group/nav-group.component';
import {NavigationService} from './navigation.service';
import { ToolbarGlobComponent } from './toolbar-glob/toolbar-glob.component';
import {CanAccessDirective} from '../../directives/can-access/can-access.directive';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {SharedMainModule} from '@app/core/modules/shared-main.module';
import {
    PIIShieldLevelSmallBadgeComponent
} from '@app/views/admin/application-settings/components/basic/pii-shield-level-info/pii-shield-level-small-badge/pii-shield-level-small-badge.component';

@NgModule({
    imports: [
        FontAwesomeModule,
        SharedMainModule,
        PIIShieldLevelSmallBadgeComponent
    ],
    exports     : [
        NavCollapseComponent,
        NavGroupComponent,
        NavItemComponent,
        ToolbarGlobComponent
    ],
    declarations: [
        NavGroupComponent,
        NavItemComponent,
        NavCollapseComponent,
        ToolbarGlobComponent
    ],
    providers: [
        NavigationService,
        CanAccessDirective
    ]
})
export class NavigationModule {
}
